import { render, staticRenderFns } from "./event_detail.vue?vue&type=template&id=8a687314&lang=pug&"
import script from "./event_detail.vue?vue&type=script&lang=js&"
export * from "./event_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports